// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner-user-table{padding:0px !important;box-shadow:none !important}`, "",{"version":3,"sources":["webpack://./src/components/user-management/user-management.scss"],"names":[],"mappings":"AAAA,oBACE,sBAAA,CACA,0BAAA","sourcesContent":[".partner-user-table {\n  padding: 0px !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
